



















































































































































































































import VCustomer from "@/shared/models/vCustomer";
import { FinDocsForSEPA } from "@/shared/models/finDocsForSepaExport";
import { GlobalFilterProperty } from "@/store/modules/globalFilters";
import DateField from "@/components/misc/DateField.vue";
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import CurrencyDisplay from "./CurrencyDisplay.vue";
import { DataOptions, DataTableHeader } from "vuetify";
import { Getter } from "vuex-class";
import { JwtClaims } from "@/store/modules/auth";
import { FinancialSettingsType } from "@/store/modules/financial";
import NumericInputImproved from "../numbers/NumericInputImproved.vue";

@Component({
  components: {
    NumericInputImproved,
    CurrencyDisplay,
    DateField,
  },
})
export default class SelectedItemsTable extends Vue {
  @PropSync("selectedItems") selected?:
    | VCustomer[]
    | GlobalFilterProperty[]
    | FinDocsForSEPA[];
  @PropSync("open") internalOpen?: boolean;
  @PropSync("tableLoading") tableLoadingInternal?: boolean[];

  @Prop({ default: false }) forOwner?: boolean;
  @Prop({ default: false }) forProperty?: boolean;
  @Prop({ default: false }) forSepa?: boolean;
  @Prop() propertyItems?: GlobalFilterProperty[];
  @Prop() ownerItems?: VCustomer[];
  @Prop() finDocItems?: FinDocsForSEPA[];
  @Prop({ default: false }) showResidentColumn?: boolean;

  @Getter("appParams/cashRegisterFeatureFlag")
  cashRegisterFeature?: boolean;

  name = "";
  email = "";

  filters = {
    ownerName: "",
    reservationHolderName: "",
    propertyName: "",
    financialDocumentNumber: "",
    financialDocumentIdentifier: "",
    financialDocumentInternalIdentifier: "",
    arrivalOrDeparture: "",
    issueDate: "",
  };
  @Watch("filters", { deep: true, immediate: true })
  watchFilters() {
    this.options.page = 1;
    this.items;
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: this.forSepa ? ["issueDate"] : ["name"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  get key() {
    return !this.forSepa
      ? this.forProperty
        ? "propertyId" : "id"
      : "financialDocumentId";
  }

  get setsFiscalAsMain() {
    return this.storedSettings?.setFiscalNumberAsMain ?? false;
  }

  ownerHeaders: DataTableHeader[] = [];
  propertyHeaders: DataTableHeader[] = [];
  reservationHeaders: DataTableHeader[] = [];
  
  @Getter("financial/settings") storedSettings?: FinancialSettingsType;

  @Getter("auth/claims") claims?: JwtClaims;
  @Watch("claims.roles", { immediate: true })
  rolesWatch() {
    this.ownerHeaders = [
      {
        text: "VCustomer.name",
        value: "name",
        width: "45%",
      },
      {
        text: "VCustomer.eMail",
        value: "eMail",
        width: "45%",
      },
      {
        text: "VCustomer.IsResident",
        value: "isResident",
        width: "10%",
      },
    ];

    this.propertyHeaders = [
      {
        text: "Property",
        value: "name",
        width: "50%",
      },
      {
        text: "Property.Owner",
        value: "ownerName",
        width: "50%",
      },
    ];

    this.reservationHeaders = [
      {
        text: "Customers.Owner",
        value: "ownerName",
      },
      {
        text: "Period",
        value: "arrivalDate",
      },
      {
        text: "Reservation holder",
        value: "reservationHolderName",
      },
      {
        text: "Property",
        value: "propertyName",
      },
      {
        text: "SepaExport.IssueDate",
        value: "issueDate",
      },
      ...(!this.setsFiscalAsMain
        ? [
            {
              text: "VFinancialDocument.documentInternalIdentifier",
              value: "financialDocumentInternalIdentifier",
            },
          ]
        : [
            {
              text: "VFinancialDocument.documentIdentifier",
              value: "financialDocumentIdentifier",
            },
          ]),
      {
        text: "Total price",
        value: "totalAmount",
      },
      {
        text: "SepaExport.PaidAmount",
        value: "totalPaidAmount",
      },
      {
        text: "SepaExport.DueAmount",
        value: "totalDueAmount",
      },
      {
        text: "SepaExport.PaymentAmount",
        value: "paymentAmount",
      },
    ];
  }

  get translatedHeaders() {
    if (this.forOwner) {
      return (
        this.ownerHeaders.map((x) => ({
          ...x,
          text: this.$t(x.text),
        })) ?? []
      );
    }

    if (this.forProperty) {
      return (
        this.propertyHeaders.map((x) => ({
          ...x,
          text: this.$t(x.text),
        })) ?? []
      );
    }

    if (this.forSepa) {
      return (
        this.reservationHeaders.map((x) => ({
          ...x,
          text: this.$t(x.text),
        })) ?? []
      );
    }
    return [];
  }

  get items() {
    if (this.forProperty) {
      return this.propertyItems?.filter(
        (e) =>
          !this.name || (e.name && e.name.toLowerCase().includes(this.name))
      );
    }
    if (this.forOwner && this.selected) {
      if (!this.ownerItems) return [];

      return this.ownerItems
        .filter(e => !this.name || (e.name && e.name.toLowerCase().includes(this.name)))
        .filter(e => !this.email || (e.eMail && e.eMail.toLowerCase().includes(this.email)));
    }
    if (this.forSepa && this.selected) {
      return this.finDocItems?.filter(
        (e) =>
          (!this.filters.ownerName ||
            (e.ownerName &&
              e.ownerName
                .toLowerCase()
                .includes(this.filters.ownerName.toLowerCase()))) &&
          (!this.filters.reservationHolderName ||
            (e.reservationHolderName &&
              e.reservationHolderName
                .toLowerCase()
                .includes(this.filters.reservationHolderName.toLowerCase()))) &&
          (!this.filters.propertyName ||
            (e.propertyName &&
              e.propertyName
                .toLowerCase()
                .includes(this.filters.propertyName.toLowerCase()))) &&
          (!this.filters.financialDocumentNumber ||
            (e.financialDocumentNumberComplete &&
              e.financialDocumentNumberComplete
                .toLowerCase()
                .includes(
                  this.filters.financialDocumentNumber.toLowerCase()
                ))) &&
          (!this.filters.financialDocumentIdentifier ||
            (e.financialDocumentIdentifier &&
              e.financialDocumentIdentifier
                .toLowerCase()
                .includes(
                  this.filters.financialDocumentIdentifier.toLowerCase()
                ))) &&
          (!this.filters.financialDocumentInternalIdentifier ||
            (e.financialDocumentInternalIdentifier &&
              e.financialDocumentInternalIdentifier
                .toLowerCase()
                .includes(
                  this.filters.financialDocumentInternalIdentifier.toLowerCase()
                ))) &&
          (!this.filters.arrivalOrDeparture ||
            (e.arrivalDate &&
              e.arrivalDate.substring(0, 10) >=
                this.filters.arrivalOrDeparture[0] &&
              e.arrivalDate <= this.filters.arrivalOrDeparture[1]) ||
            (e.departureDate &&
              e.departureDate.substring(0, 10) <=
                this.filters.arrivalOrDeparture[1] &&
              e.departureDate >= this.filters.arrivalOrDeparture[0])) &&
          (!this.filters.issueDate ||
            (e.issueDate &&
              e.issueDate.substring(0, 10) === this.filters.issueDate))
      );
    }
    return [];
  }

  areAllSelected() {
    if (this.selected?.length == 0) {
      return false;
    }
    if (this.forOwner) {
      const selectedOwners = this.selected as VCustomer[];
      const items = this.items as VCustomer[];
      return !items.some((e) => selectedOwners?.indexOf(e) == -1);
    }
    if (this.forProperty) {
      const selectedProperties = this.selected as GlobalFilterProperty[];
      const items = this.items as GlobalFilterProperty[];
      return !items.some((e) => selectedProperties?.indexOf(e) == -1);
    }
    if (this.forSepa) {
      const selectedFinDocItems = this.selected as FinDocsForSEPA[];
      const items = this.items as FinDocsForSEPA[];
      return !items.some((e) => selectedFinDocItems?.indexOf(e) == -1);
    }
  }

  selectAll(event: boolean) {
    if (this.forOwner) {
      const selectedOwners = this.selected as VCustomer[];
      const items = this.items as VCustomer[];

      if (event) {
        this.selected = selectedOwners.concat(
          items?.filter((e) => !selectedOwners.some((s) => s.id == e.id))
        );
      } else {
        this.selected = selectedOwners.filter(
          (s) => !items.some((e) => e.id == s.id)
        );
      }
    } else if (this.forProperty) {
      const selectedProperties = this.selected as GlobalFilterProperty[];
      const items = this.items as GlobalFilterProperty[];

      if (event) {
        this.selected = selectedProperties.concat(
          items?.filter(
            (e) => !selectedProperties.some((s) => s.propertyId == e.propertyId)
          )
        );
      } else {
        this.selected = selectedProperties.filter(
          (s) => !items.some((e) => e.propertyId == s.propertyId)
        );
      }
    } else if (this.forSepa) {
      const selectedFinDocs = this.selected as FinDocsForSEPA[];
      const items = this.items as FinDocsForSEPA[];

      if (event) {
        this.selected = selectedFinDocs.concat(
          items?.filter(
            (e) =>
              !selectedFinDocs.some(
                (s) => s.financialDocumentId == e.financialDocumentId
              )
          )
        );
      } else {
        this.selected = selectedFinDocs.filter(
          (s) =>
            !items.some((e) => e.financialDocumentId == s.financialDocumentId)
        );
      }
    }
  }
}
